


















































































































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import orderInfo from './components/OrderInfo.vue'
const loginerModule = namespace('loginer')
const TRANSFOR_KEY: string = 'goods_name'
const sumCol = ['goods_num', 'sub_total_send', 'goods_assist_num']
@Component({
	components: {
		orderInfo
	}
})
export default class RestaurantOrderDetails extends Vue {
	@loginerModule.State('loginerEmail') private loginerEmail?: string
	private orderData: any = {}
	private orderid: string = ''
	private printerVisible: boolean = false
	private searchKey: string = ''
	private get tableData () {
		return this.transforDetails(this.orderData.details)
	}
	private created () {
		this.refreshOrderDetails()
	}
	private mounted () {
		(this as any).$refs.fxTable.doLayout()
	}
	private updated () {
		this.$nextTick(() => {
			(this as any).$refs.fxTable.doLayout()
		})
	}
	private isBillState (state: any) {
		return (this as any).$fxStateMiddleware.stateIs('stateReturn')(state)(this.orderData.bill_state)
	}
	private refreshOrderDetails () {
		return Promise.all([this.getOrderDetails((this as any).$route.query.id)])
	}
	private onPrintClick (): void {
		const params = (this as any).$route.query.id
		this.orderid = params
		this.printerVisible = true
	}
	private getOrderDetails (id: string): void {
		const params = {
			bill_id: id
		}
		return (this as any).$fxHttp.requestPost({
			url: '/business/billWithDetail',
			data: params,
			fullData: true
		}).then((res: any) => {
			const isZ5 = res.otherdata == null ? false : res.otherdata.isZ5
			const forceUploadPermitFlag = res.otherdata && res.otherdata.forceUploadPermitFlag

			if (!isZ5 && forceUploadPermitFlag === true) {
				this.$message.warning('请上传供货商证照信息！')
				this.$router.replace({path: 'systemSet'})
				return Promise.reject()
			}
			this.orderData = res.data
		})
	}
	private transforDetails (goodDetails: any = []) {
		return goodDetails.filter((item: any) => {
			return item[TRANSFOR_KEY].indexOf(this.searchKey.trim()) >= 0
		})
	}
	private onAgreenClick () {
		(this as any).$fxConfirm('是否同意此单据？').then(() => {
			this.onAgreenHandler().then(() => {
				(this as any).$fxMessage.success('同意单据成功').then(this.refreshOrderDetails)
			})
		})
	}
	private onAgreenHandler () {
		const params = {
			bill_state: 21,
			id: this.orderData.id
		}
		return (this as any).$fxHttp.requestPost({
			url: '/business/bill/updateBillState',
			data: params
		}).then((res: any) => {
			return Promise.resolve()
		})
	}
	private onReturnClick () {
		(this as any).$fxConfirm('是否退回此单据？').then(() => {
			this.onReturnHandler().then(() => {
				(this as any).$fxMessage.success('退回单据成功').then(() => {
					this.$router.go(-1)
				})
			})
		})
	}
	private onReturnHandler () {
		const params = {
			bill_state: 29,
			id: this.orderData.id
		}
		return (this as any).$fxHttp.requestPost({
			url: '/business/bill/updateBillState',
			data: params
		}).then((res: any) => {
			return Promise.resolve()
		})
	}
	private onSendExcelClick () {
		if (!this.loginerEmail) {
			(this as any).$fxMessage.warning('用户尚未绑定邮箱')
			return false
		}
		(this as any).$fxConfirm('是否确定将单据导出Excel并发送至绑定邮箱？').then(() => {
			this.onSendExcelHandler()
		})
	}
	private onSendExcelHandler () {
		const params = {
			bill_id: (this as any).$route.query.id
		}
		return (this as any).$fxHttp.requestPost({
			url: '/business/8001',
			data: params
		}).then((res: any) => {
			(this as any).$fxMessage.success('邮件发送成功')
		})
	}
	private onExportClick () {
		(this as any).$fxConfirm('是否确定导出本单据？').then(() => {
			this.onExportHandler()
		})
	}
	private onExportHandler () {
		const params = (this as any).$route.query.id
		window.open('/cldEdi/export/exportReturnBill.do?billId=' + params)
	}
	private getSummaries (param: any) {
		const { columns, data } = param
		return columns.map((item: any, index: number) => {
			if (index === 0) {
				return '合计'
			} else if (sumCol.includes(item.property)) {
				return (this as any).$fxUtils.arrSum(data, (sumItem: any) => {
					return sumItem[item.property]
				})
			} else {
				return ''
			}
		})
	}
}
